import adminEn from './locales/en/admin.json';
import adminPt from './locales/pt/admin.json';
import communityEn from './locales/en/community.json';
import communityPt from './locales/pt/community.json';
import p2eEn from './locales/en/p2e.json';
import p2ePt from './locales/pt/p2e.json';

export const defaultNS = 'admin';
export const fallbackLng = 'en';

export const resources = {
  en: {
    admin: adminEn,
    community: communityEn,
    p2e: p2eEn,
  },
  pt: {
    admin: adminPt,
    community: communityPt,
    p2e: p2ePt,
  },
} as const;

export const supportedLocales = Object.keys(resources) as Array<keyof typeof resources>;

